export { default } from './SettingsCogOutline'
